import React from "react";
import Page from "components/Page";
import { Props } from "./EmailTemplates";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const EmailTemplates = lazyWithRetry(() => import("./EmailTemplates"));

export default (props: Props) => (
  <Page>
    <EmailTemplates {...props} />
  </Page>
);
